import type { SidePanel } from '../types';

export const Withdrawals: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./WithdrawalsPanel.vue')),
};
